import { render, staticRenderFns } from "./MailSegnalazioneAttachments.vue?vue&type=template&id=4985bf97&scoped=true"
import script from "./MailSegnalazioneAttachments.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneAttachments.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneAttachments.vue?vue&type=style&index=0&id=4985bf97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985bf97",
  null
  
)

export default component.exports